module.exports = __webpack_public_path__ + "img/newLogo.bc166b76.png";